import PropTypes from 'prop-types';
import TreeItem from './TreeItem/TreeItem';
import { hierarchy } from 'd3-hierarchy';

import styles from './TreeView.module.scss';
import { useSelector } from 'react-redux';

const TreeView = ({ hierarchy, onChange, onOpen, ...props }) => {
    const currentLocale = useSelector(state => state?.locale?.current);
    const treeItems = hierarchy => {
        if (hierarchy?.children) {
            return hierarchy.children.map(item =>
                <TreeItem
                    key={item.data.id}
                    id={item.data.id}
                    label={item.data.name[currentLocale]}
                    checked={item.data.checked}
                    indeterminate={item.data.indeterminate}
                    disabled={item.data.disabled}
                    onChange={onChange}
                    open={item.data.open}
                    onOpen={onOpen}
                    data-testid={(props['data-testid'] ? props['data-testid'] + '-' : 'treeItem-') + item.data.name[currentLocale]}
                >
                    { item?.children && treeItems(item) }
                </TreeItem>
            );
        }
        return null;
    };
    return <div className={styles.container}>
        {treeItems(hierarchy)}
    </div>;
};

TreeView.propTypes = {
    hierarchy: PropTypes.instanceOf(hierarchy),
    onChange: PropTypes.func.isRequired,
    onOpen: PropTypes.func,
    'data-testid': PropTypes.string
};

export default TreeView;
